import { lock, unlock } from 'tua-body-scroll-lock';
import * as focusTrap from 'focus-trap';
import parseHTML from '../utils/_parseHtml';

class mFullscreenImages extends HTMLDivElement {
    constructor() {
        super();
        this.closeButton = this.querySelector('button');
        this.imagesContainer = this.querySelector('section');
        // bind this in showZoom, escapeKey
        this.toggleZoom = this.toggleZoom.bind(this);
        this.escapeKey = this.escapeKey.bind(this);

        this.touchStartHandler = this.touchStartHandler.bind(this);
        this.touchEndHandler = this.touchEndHandler.bind(this);
    }

    connectedCallback() {
        document.addEventListener('oFullScreenImages:showZoom', (e) => { this.toggleZoom(e); });
        this.addEventListener('click', this.toggleZoom);
    }

    touchStartHandler(e) {
        if (e.touches.length > 1) {
            this.isZooming = true;
            unlock(this);
        }
    }

    touchEndHandler(e) {
        if (this.isZooming) {
            this.isZooming = false;
            lock(this);
        }
    }

    toggleZoom(e) {
        var isShow = this.getAttribute('aria-hidden') === 'true'; // true == showin / false == hiding
        this.setAttribute('aria-hidden', !isShow); // invert aria-hidden
        this.closeButton.setAttribute('tabindex', isShow ? '0' : '-1'); // invert button tabindex
        if (isShow) {
            this.isZooming = false;

            this.imagesContainer.addEventListener('touchstart', this.touchStartHandler);
            this.imagesContainer.addEventListener('touchend', this.touchEndHandler);

            this.trap = focusTrap.createFocusTrap(this); // create and init Focus Trap
            this.trap.activate();
            window.addEventListener('keydown', this.escapeKey); // add listener for escape key event -> Close
            // Fill component with custom html
            if (e && e.detail && e.detail.imagesContainer && e.detail.currentImage) {
                var imagesHtml = e.detail.imagesContainer;
                var currentImageIndex = 0;
                var isSwiperInitialised = e.detail.imagesContainer.classList.contains('swiper-initialized');
                var htmlElement;
                // if swiper is initialised, use pre-swiper init html as swiper can duplicates slides (see m-pdp-images)
                if (!isSwiperInitialised) {
                    htmlElement = parseHTML(imagesHtml.querySelector('.zoom-wrapper').innerHTML);
                } else {
                    htmlElement = parseHTML(e.detail.imagesContainer.originalHtml);
                }
                var images = htmlElement.querySelectorAll('img');
                for (var image of images) {
                    image.srcset = image.srcset + ',' + image.dataset.hdSrcset; // add HD images to srcset
                    image.removeAttribute('sizes');
                    image.classList.add('a-loader-white'); // add a spinning loader visible while img is not loaded
                    image.parentNode.dataset.gtmValue = 'Close image';
                }
                var htmlElementHtml = [].map.call(htmlElement.childNodes, x => x.outerHTML).join(''); // Get html from Document Fragment
                this.imagesContainer.innerHTML = htmlElementHtml;
                // currentImage can be an img (click), a zoom button (keyboard) or a video:
                // closest('.swiper-slide') normalizes them to the actual slide element
                if (!isSwiperInitialised) {
                    var slideEl = e.detail.currentImage.closest('.swiper-slide');
                    currentImageIndex = Array.from(slideEl.parentNode.children).indexOf(slideEl);
                } else {
                    currentImageIndex = e.detail.currentImage.closest('.swiper-slide').dataset.swiperSlideIndex;
                }
                var currentImage = this.imagesContainer.children[currentImageIndex];
                if (currentImage) {
                    var currentImageOffsetTop = currentImage.offsetTop;
                    this.scrollTop = currentImageOffsetTop;
                }
            }
        } else { // Release body scroll, focusTrap, remove escape key listener
            unlock(this);
            this.scrollTop = 0;
            window.removeEventListener('keydown', this.escapeKey);

            this.imagesContainer.removeEventListener('touchstart', this.touchStartHandler);
            this.imagesContainer.removeEventListener('touchend', this.touchEndHandler);

            this.trap.deactivate();
        }
    }

    escapeKey(e) {
        if (e.code === 'Escape') {
            this.toggleZoom();
        }
    }
}

customElements.define('m-fullscreen-images', mFullscreenImages, {
    extends: 'div'
});
